import { iconsSet } from "../../../../assets/icons/icons";

export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_quantroots.png",
      alt: "Estratégias Quantroots",
    },
    title: "Quant Roots – Onde a Tecnologia Transforma Seus Investimentos!",

    // String ou array de strings
    text: "Você já imaginou operar como os grandes players do mercado? Com o Método Quant Roots, você acessa estratégias automatizadas de alto nível, desenvolvidas para otimizar sua rentabilidade e reduzir riscos. Aqui, a inteligência artificial e os algoritmos quantitativos trabalham para você, garantindo operações mais eficientes e estratégicas.",
    testimonial: {
      text: "",
      author: {
        name: "",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },

  strategies: {
    title: "ESTRATÉGIAS QUANT ROOTS",
    heading: "O Que Você Vai Encontrar?",
    subtitle: [
      "- Robôs Investidores e Sinais Automatizados – Domine operações inteligentes sem precisar acompanhar o mercado 24/7.",
      "- Gestão Quantitativa de Portfolios – Estratégias diversificadas para maximizar ganhos e minimizar riscos.",
      "- Swing Trade, Scalping e Médio Prazo – Operações calibradas para capturar oportunidades em qualquer cenário.",
      "- Bitcoin, Mini Dólar e Mini Índice – Explore o potencial dos ativos mais líquidos da bolsa com um portfólio balanceado.",
    ],
  },

  cta: {
    title: "Comece Agora e Transforme Seus Resultados!",
    subtitle: "Potencialize seus resultados com o Quant Roots e tenha a tecnologia operando por você.",
    buttonText: "Quero começar",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Quant Roots",
    col1: [
      "Somos apaixonados pelo mercado financeiro e movidos pela busca incessante pela consistência e simplicidade nas operações. Acreditamos que operar no mercado não precisa ser um jogo de adivinhação ou um campo minado de informações confusas. Foi com essa visão que criamos o Método Quant Roots baseado em conceitos simples e poderosos. Aqui, simples significa eficaz.",
    ],
    col2: [
      "Nosso propósito é claro: empoderar você com estratégias automatizadas para você investir com segurança, confiança e inteligência. Nosso compromisso é com a realidade do mercado e como aproveitar cada oportunidade para ter consistência e excelentes resultados. ",
    ],
  },

  features: {
    // type: 2,
    title: "Por que utilizar os robôs da Quant Roots?",
    subtitle: "Veja quais as principais vantagens dos robôs da Quant Roots.",
    data: [
      {
        icon: iconsSet.play_circle,
        title: "Tecnologia de Ponta",
        description: "Inteligência artificial e modelos quantitativos operando a seu favor.",
      },
      {
        icon: iconsSet.tune,
        title: "Otimização de Resultados",
        description: "Redução de erros humanos e aprimoramento da performance sempre.",
      },
      {
        icon: iconsSet.settings_outline,
        title: "Automação Completa",
        description: "Você define as regras e deixa a tecnologia fazer o trabalho pesado.",
      },
      {
        icon: iconsSet.pie_chart,
        title: "Backtest e Estatísticas",
        description: "Estratégias testadas e validadas com dados reais do mercado.",
      },
      {
        icon: iconsSet.chart,
        title: "Adaptação Dinâmica ao Mercado",
        description:
          "Nossos algoritmos são ajustados constantemente para garantir que sua estratégia esteja sempre otimizada.",
      },
      {
        icon: iconsSet.favorite,
        title: "Tomada de Decisão sem Emoção",
        description:
          "Com o Quant Roots, as decisões são 100% baseadas em estatísticas e algoritmos inteligentes, eliminando impulsos e garantindo operações mais eficientes. ",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos.",
  },
};
